<form novalidate [formGroup]="manageCustomerForm" (ngSubmit)="setCustomer()">
    <div class="fdx-c-notification__backdrop fdx-c-notification--position-bottom-right">
        <div class="fdx-c-notification fdx-c-notification--block fdx-c-notification--error">
            <div class="fdx-c-notification__main">
                <div class="fdx-c-notification__body">
                    <h3 class="fdx-c-notification__title">
                        {{"COMMON.CommonManagecustomerTitle_Pleasechooseacustomer" | translate: {Default: "Please choose a customer"} }}
                    </h3>
                    <div class="fdx-c-notification__description">

                        <div
                            class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--float-label fdx-c-form-group--has-value">
                            <span class="fdx-c-form-group__item">
                                <select id="dropdown" class="fdx-c-form-group__select" formControlName="customerCtrl"
                                    (change)="setCustomer()">
                                    <option value="-1" selected="">
                                        {{"APP.AppOption_Pleaseselect" | translate: {Default: "Please Select"} }}
                                    </option>
                                    <option *ngFor="let cust of customers" value="{{cust.customerId}}">
                                        {{cust.customerName}}
                                    </option>
                                </select>
                                <div class="fdx-c-form-group__icon">
                                    <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                                        <use xlink:href="#chevron"></use>
                                    </svg>
                                </div>
                            </span>
                        </div>                        
                    </div>
                </div>
                <div class="fdx-c-notification__footer">
                    <button class="fdx-c-button fdx-c-button--icon" aria-label="close notification message: lorem ipsum"
                        (click)="close()">
                        <svg class="fdx-c-icon" aria-hidden="true">
                            <use href="#cross"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    
    
    <!--
<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
    Launch demo modal
  </button>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Please choose a customer</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div
            class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--float-label fdx-c-form-group--has-value">
            <span class="fdx-c-form-group__item">
                <select id="dropdown" class="fdx-c-form-group__select" formControlName="customerCtrl">
                    <option value="-1" selected="">{{"APP.AppOption_Pleaseselect" | translate: {Default: "Please Select"} }}</option>
                    <option *ngFor="let cust of customers" value="{{cust.cusId}}">
                        {{cust.custName}}
                    </option>
                </select>
                <div class="fdx-c-form-group__icon">
                    <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                        <use xlink:href="#chevron"></use>
                    </svg>
                </div>
            </span>
        </div>   
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary"  (click)="setCustomer()">Save changes</button>
        </div>
      </div>
    </div>
  </div>-->
</form>